<template>
  <article class="turn_calendar">
        <div class="turn_calendar__week-row" v-for="(week,i) in currentDates" :key=i>
          
          <div :class="{'active': day.isToday}" class="turn_calendar__day-box" v-for="(day,j) in week" :key=j>
            <h5  v-if="i==0" > {{weeks[j]}}</h5>
            <h4 :class="{'active': !day.isCurMonth}">{{day.monthDay}}</h4>
            <div v-if="day.isCurMonth && (day.monthDay in turns)" class="turn_calendar__day-box__turns" >
              <div v-for="(turn,t) in turns[day.monthDay]" :key="t">
                <div @click="goToTurn(turn.id)" :class="turns[day.monthDay][t].is_diurnal? 'turn_calendar__day-box__turns--day':'turn_calendar__day-box__turns--night'">
                  {{turnHour(turns[day.monthDay][t],day.monthDay)}}
                  <span>
                    <p>{{turns[day.monthDay][t].device.company}}</p>
                    {{turns[day.monthDay][t].device.location}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
    
    
  </article>
</template>

<script>

import moment from 'moment';

export default {
  props:{
    currentMonth: {},
    unprocessedTurns: {}
  },
  data(){
    return{

      
      dateFunc: {
        
        getMonthViewStartDate (date, firstDay) {
          
          firstDay = parseInt(firstDay);
          let start = moment(date);
          let startOfMonth = moment(start.startOf('month'));

          start.subtract(startOfMonth.day(), 'days');

          if (startOfMonth.day() < firstDay) {
            start.subtract(7, 'days'); 
          }

          start.add(firstDay, 'days');
          //console.log(start);

          return start;
        },
        getMonthViewEndDate (date) {
          return this.getMonthViewStartDate().add(6, 'weeks');
        }
      },
     
      turns:{},
      weeks:['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'],
      
    }
  },
  methods:{
    
    getCalendar () {

      //Genera el calendario

      // calculate 2d-array of each month
      let monthViewStartDate = this.dateFunc.getMonthViewStartDate(this.currentMonth, this.firstDay);
      let calendar = [];
      for(let perWeek = 0 ; perWeek < 6 ; perWeek++) {
        let week = [];
        for(let perDay = 0 ; perDay < 7 ; perDay++) {
          week.push({
            monthDay : monthViewStartDate.date(),
            isToday : monthViewStartDate.isSame(moment(), 'day'),
            isCurMonth : monthViewStartDate.isSame(this.currentMonth, 'month'),
            weekDay : perDay,
            date : moment(monthViewStartDate),
            //events : this.slotEvents(monthViewStartDate)
          });
          monthViewStartDate.add(1, 'day');

        }
        calendar.push(week);
      }
      return calendar
    },

    goToTurn(id){
      //redirecciona a la vista del turno
      this.$router.push({ path: '/turn/' + id });
    },


    processTurns(turns){
      //Procesa los turnos recibidos por el backend
      
      //console.log("Turnos sin procesar");
      //console.log(turns);     
      var processedTurns = {}
      var getDate = function(dateString){
        return moment(dateString).format('D');
      }
      turns.forEach(function(turn){
        var day = getDate(turn.start_date);       
        if(processedTurns[day]){          
          processedTurns[day].push(turn);
        }else{          
          processedTurns[day] = [turn];
                    
        }
        if(turn.end_date){
          console.log("ENTROOOOO");
          console.log(turn);
          if(turn.end_date!=turn.start_date){
            var comparable=moment('6:00','H');
            var t1 = JSON.parse(JSON.stringify(turn));            
            if(moment(turn.end_hour,'H').isSameOrAfter(comparable)){
                 t1.is_diurnal=true;
            }else{
                  t1.is_diurnal=false;
            }               
            
            if(processedTurns[parseInt(day)+1]){          
              processedTurns[parseInt(day)+1].push(t1);
            }else{         
              processedTurns[parseInt(day)+1] = [t1];
                    
            } 
          }
        }
        
      })      
      //console.log("Turnos procesados");
      //console.log(processedTurns);
      return processedTurns;
    },
    turnHour(turn,day){
      var getDate = function(dateString){
        return moment(dateString).format('D');
      }
      
      //Dado un turno retorna hora inicio y hora fin separados por guión
      if(turn.start_date==turn.end_date){
        return turn.start_hour + '-' + turn.end_hour;
      }
      else if(turn.end_date==null && turn.end_hour){
        return turn.start_hour + '-' + turn.end_hour+"*";
      }
      else if(getDate(turn.start_date)==day ){
          return turn.start_hour + "-";
      }
      else{
          return '-' + turn.end_hour;
      }
    }
    

  },
  computed:{
    currentDates () {
        return this.getCalendar()
      }
  },
  created(){
    //Procesa los turnos recibidos por el backend para que puedan ser mostrados en el calendario 
    this.turns = this.processTurns(this.unprocessedTurns);
    
  },
  watch:{
    unprocessedTurns: function(val){
      this.turns = this.processTurns(this.unprocessedTurns);
      
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Calendar.vue